// export const getRegions = () => {
//     const regions = [];
//     REG_MUN.map((item) => !regions.includes(item.REG_ATVK) && regions.push(item.REG_ATVK));

//     const target = {};
//     regions.forEach((key) => (target[key] = getRegionMunicipalities(key)));
//     console.log("target", JSON.stringify(target));
// };

// const getRegionMunicipalities = (region: string) => {
//     const muns = [];
//     REG_MUN.map((item) => {
//         item.REG_ATVK === region && muns.push(item.MUN_ATVK);
//     });
//     return muns;
// };

export const region_Municipalities: { [region: string]: string[] } = {
    "1000": [],
    "2000": [],
    "3000": [],
    "4000": [],
    "5000": [],
    "6000": [],
    "7000": [],
    "20000": [
        "20200",
        "20210",
        "20420",
        "20440",
        "20230",
        "20550",
        "20460",
        "20490",
        "20500",
        "20430",
        "20510",
        "20220",
        "20410",
        "20520",
        "20450",
        "20400",
        "20540",
        "20570",
        "20470",
        "20480",
        "20530",
        "20560"
    ],
    "21000": [
        "21200",
        "21460",
        "21490",
        "21530",
        "21420",
        "21500",
        "21510",
        "21450",
        "21540",
        "21430",
        "21470",
        "21520",
        "21440",
        "21480",
        "21400",
        "21410"
    ],
    "22000": [
        "22200",
        "22400",
        "22210",
        "22620",
        "22440",
        "22640",
        "22530",
        "22550",
        "22430",
        "22540",
        "22600",
        "22410",
        "22590",
        "22420",
        "22580",
        "22560",
        "22570",
        "22630",
        "22490",
        "22510",
        "22460",
        "22470",
        "22500",
        "22450",
        "22520",
        "22610",
        "22480"
    ],
    "23000": ["23410", "23400"],
    "24000": [
        "24210",
        "24530",
        "24570",
        "24400",
        "24560",
        "24510",
        "24520",
        "24200",
        "24420",
        "24450",
        "24470",
        "24460",
        "24580",
        "24500",
        "24440",
        "24430",
        "24490",
        "24410",
        "24540",
        "24550",
        "24480"
    ],
    "25000": [
        "25510",
        "25200",
        "25450",
        "25540",
        "25570",
        "25500",
        "25560",
        "25490",
        "25210",
        "25410",
        "25480",
        "25440",
        "25430",
        "25530",
        "25520",
        "25550",
        "25400",
        "25470",
        "25460",
        "25420"
    ],
    "26000": [
        "26210",
        "26600",
        "26420",
        "26200",
        "26550",
        "26450",
        "26540",
        "26570",
        "26490",
        "26460",
        "26440",
        "26520",
        "26470",
        "26510",
        "26500",
        "26580",
        "26590",
        "26430",
        "26530",
        "26560",
        "26400",
        "26480",
        "26410"
    ],
    "27000": [
        "27470",
        "27200",
        "27220",
        "27540",
        "27240",
        "27530",
        "27640",
        "27460",
        "27430",
        "27570",
        "27620",
        "27210",
        "27400",
        "27510",
        "27410",
        "27230",
        "27580",
        "27550",
        "27490",
        "27420",
        "27560",
        "27630",
        "27520",
        "27610",
        "27480",
        "27600",
        "27500",
        "27650",
        "27590",
        "27440",
        "27450"
    ],
    "28000": [
        "28210",
        "28580",
        "28460",
        "28420",
        "28200",
        "28470",
        "28550",
        "28570",
        "28540",
        "28440",
        "28430",
        "28450",
        "28480",
        "28530",
        "28500",
        "28490",
        "28510",
        "28400",
        "28520",
        "28560",
        "28410"
    ],
    "29000": [
        "29410",
        "29420",
        "29500",
        "29200",
        "29520",
        "29430",
        "29440",
        "29490",
        "29400",
        "29480",
        "29470",
        "29460",
        "29510",
        "29450"
    ],
    "30000": [
        "30520",
        "30480",
        "30540",
        "30550",
        "30450",
        "30510",
        "30460",
        "30500",
        "30430",
        "30420",
        "30490",
        "30530",
        "30400",
        "30440",
        "30470",
        "30410"
    ],
    "31000": [
        "31420",
        "31550",
        "31200",
        "31510",
        "31500",
        "31570",
        "31430",
        "31590",
        "31600",
        "31470",
        "31520",
        "31450",
        "31210",
        "31560",
        "31400",
        "31530",
        "31460",
        "31610",
        "31490",
        "31410",
        "31540",
        "31580",
        "31480",
        "31440",
        "31010"
    ],
    "32000": [
        "32620",
        "32450",
        "32210",
        "32630",
        "32480",
        "32430",
        "32570",
        "32410",
        "32580",
        "32200",
        "32590",
        "32510",
        "32560",
        "32500",
        "32400",
        "32600",
        "32530",
        "32470",
        "32550",
        "32520",
        "32540",
        "32440",
        "32490",
        "32460",
        "32420",
        "32610"
    ],
    "33000": [
        "33210",
        "33540",
        "33430",
        "33200",
        "33480",
        "33500",
        "33550",
        "33420",
        "33560",
        "33470",
        "33570",
        "33530",
        "33460",
        "33410",
        "33510",
        "33520",
        "33450",
        "33440",
        "33400",
        "33490"
    ],
    "34000": ["34410", "34210", "34400", "34200", "34420"],
    "35000": [
        "35240",
        "35530",
        "35230",
        "35220",
        "35200",
        "35210",
        "35510",
        "35410",
        "35430",
        "35400",
        "35440",
        "35490",
        "35460",
        "35480",
        "35520",
        "35500",
        "35470",
        "35450",
        "35420"
    ],
    "36000": ["36420", "36200", "36400", "36440", "36430", "36410"],
    "37000": [
        "37490",
        "37210",
        "37570",
        "37200",
        "37220",
        "37600",
        "37420",
        "37610",
        "37430",
        "37550",
        "37590",
        "37520",
        "37440",
        "37400",
        "37510",
        "37470",
        "37560",
        "37410",
        "37530",
        "37480",
        "37580",
        "37450",
        "37500",
        "37540",
        "37460"
    ],
    "38000": [
        "38210",
        "38220",
        "38530",
        "38200",
        "38490",
        "38570",
        "38510",
        "38450",
        "38430",
        "38500",
        "38480",
        "38460",
        "38520",
        "38440",
        "38560",
        "38550",
        "38420",
        "38580",
        "38400",
        "38470",
        "38540",
        "38410"
    ],
    "39000": ["39400", "39410", "39420"],
    "40000": [
        "40010",
        "40520",
        "40220",
        "40210",
        "40200",
        "40450",
        "40470",
        "40480",
        "40490",
        "40440",
        "40550",
        "40410",
        "40420",
        "40430",
        "40540",
        "40460",
        "40510",
        "40400",
        "40530",
        "40500"
    ],
    "41000": ["41400", "41200"],
    "42000": [
        "42460",
        "42410",
        "42430",
        "42400",
        "42520",
        "42490",
        "42200",
        "42530",
        "42450",
        "42470",
        "42500",
        "42480",
        "42420",
        "42510",
        "42440"
    ],
    "43000": [
        "43500",
        "43600",
        "43660",
        "43400",
        "43650",
        "43440",
        "43480",
        "43520",
        "43200",
        "43470",
        "43420",
        "43640",
        "43510",
        "43670",
        "43530",
        "43490",
        "43610",
        "43430",
        "43410",
        "43630",
        "43450",
        "43620",
        "43560",
        "43460",
        "43540",
        "43570",
        "43550",
        "43580",
        "43590"
    ],
    "44000": ["44200", "44420", "44410", "44400"],
    "45000": ["45200", "45400"],
    "46000": [
        "46510",
        "46210",
        "46400",
        "46570",
        "46420",
        "46490",
        "46460",
        "46550",
        "46530",
        "46520",
        "46200",
        "46410",
        "46580",
        "46480",
        "46540",
        "46450",
        "46560",
        "46430",
        "46470",
        "46440",
        "46500"
    ],
    "47000": ["47200", "47400", "47410"],
    "48000": ["48430", "48200", "48460", "48400", "48450", "48420", "48440", "48410"],
    "49000": [
        "49430",
        "49400",
        "49210",
        "49200",
        "49470",
        "49480",
        "49450",
        "49520",
        "49490",
        "49460",
        "49500",
        "49410",
        "49530",
        "49510",
        "49440",
        "49420"
    ],
    "51000": [
        "51210",
        "51490",
        "51220",
        "51200",
        "51230",
        "51500",
        "51570",
        "51450",
        "51530",
        "51540",
        "51510",
        "51550",
        "51440",
        "51420",
        "51470",
        "51430",
        "51480",
        "51400",
        "51410",
        "51460",
        "51560",
        "51520"
    ],
    "52000": [
        "52420",
        "52200",
        "52570",
        "52530",
        "52510",
        "52550",
        "52560",
        "52600",
        "52540",
        "52400",
        "52520",
        "52460",
        "52500",
        "52490",
        "52590",
        "52430",
        "52440",
        "52450",
        "52480",
        "52410",
        "52580",
        "52210",
        "52470"
    ],
    "53000": ["53200", "53420", "53440", "53410", "53400", "53430"],
    "54000": [
        "54600",
        "54550",
        "54200",
        "54430",
        "54230",
        "54210",
        "54220",
        "54530",
        "54570",
        "54640",
        "54500",
        "54520",
        "54590",
        "54420",
        "54650",
        "54510",
        "54610",
        "54400",
        "54470",
        "54480",
        "54490",
        "54580",
        "54620",
        "54540",
        "54010",
        "54450",
        "54460",
        "54440",
        "54410",
        "54630",
        "54560"
    ],
    "55000": ["55200", "55410", "55400"],
    "56000": [
        "56440",
        "56480",
        "56200",
        "56450",
        "56410",
        "56400",
        "56470",
        "56500",
        "56490",
        "56420",
        "56430",
        "56510",
        "56460"
    ]
};

export const lvmForestry_Municipalities: { [lvmForestry: string]: string[] } = {
    "1": [
        "21200",
        "21400",
        "21410",
        "21420",
        "21430",
        "21440",
        "21450",
        "21460",
        "21470",
        "21480",
        "21490",
        "21500",
        "21510",
        "21520",
        "21530",
        "21540",
        "24460",
        "26440",
        "29200",
        "29400",
        "29410",
        "29420",
        "29430",
        "29440",
        "29450",
        "29460",
        "29470",
        "29480",
        "29490",
        "29500",
        "29510",
        "29520",
        "38430",
        "38440",
        "49200",
        "49210",
        "49400",
        "49410",
        "49420",
        "49430",
        "49440",
        "49450",
        "49460",
        "49470",
        "49480",
        "49490",
        "49500",
        "49510",
        "49520",
        "49530",
        "53200",
        "53400",
        "53410",
        "53420",
        "53430",
        "53440",
        "54220",
        "54230",
        "54410",
        "54440",
        "54470",
        "54540",
        "54550",
        "54570",
        "54600"
    ],
    "2": [
        "27200",
        "27210",
        "27220",
        "27230",
        "27240",
        "27400",
        "27410",
        "27420",
        "27430",
        "27440",
        "27450",
        "27460",
        "27470",
        "27480",
        "27490",
        "27500",
        "27510",
        "27520",
        "27530",
        "27540",
        "27550",
        "27560",
        "27570",
        "27580",
        "27590",
        "27600",
        "27610",
        "27620",
        "27630",
        "27640",
        "27650",
        "28450",
        "28580",
        "33200",
        "33210",
        "33400",
        "33410",
        "33420",
        "33430",
        "33440",
        "33450",
        "33460",
        "33470",
        "33480",
        "33490",
        "33500",
        "33510",
        "33520",
        "33530",
        "33540",
        "33550",
        "33560",
        "33570",
        "46200",
        "46210",
        "46400",
        "46410",
        "46420",
        "46430",
        "46440",
        "46450",
        "46460",
        "46470",
        "46480",
        "46490",
        "46500",
        "46510",
        "46520",
        "46530",
        "46540",
        "46560",
        "46570",
        "46580",
        "51400",
        "52560",
        "52570",
        "52580",
        "56410",
        "56470",
        "56500"
    ],
    "3": [
        "20550",
        "20570",
        "22200",
        "22210",
        "22400",
        "22410",
        "22420",
        "22430",
        "22440",
        "22450",
        "22460",
        "22470",
        "22480",
        "22490",
        "22500",
        "22510",
        "22520",
        "22530",
        "22540",
        "22550",
        "22560",
        "22570",
        "22580",
        "22590",
        "22600",
        "22610",
        "22620",
        "22630",
        "22640",
        "31010",
        "31200",
        "31210",
        "31400",
        "31410",
        "31420",
        "31430",
        "31440",
        "31450",
        "31460",
        "31470",
        "31480",
        "31490",
        "31500",
        "31510",
        "31520",
        "31530",
        "31540",
        "31550",
        "31560",
        "31570",
        "31580",
        "31590",
        "31600",
        "31610",
        "32200",
        "32210",
        "32400",
        "32410",
        "32420",
        "32430",
        "32440",
        "32450",
        "32460",
        "32470",
        "32480",
        "32490",
        "32500",
        "32510",
        "32520",
        "32530",
        "32540",
        "32550",
        "32560",
        "32570",
        "32580",
        "32590",
        "32600",
        "32620",
        "32630",
        "36200",
        "36400",
        "36410",
        "36420",
        "36430",
        "36440",
        "37580",
        "38510",
        "42200",
        "42400",
        "42410",
        "42420",
        "42430",
        "42440",
        "42450",
        "42460",
        "42470",
        "42480",
        "42490",
        "42500",
        "42510",
        "42520",
        "42530",
        "43450",
        "43620",
        "43670"
    ],
    "4": [
        "23400",
        "23410",
        "26200",
        "26210",
        "26400",
        "26410",
        "26420",
        "26430",
        "26440",
        "26450",
        "26460",
        "26470",
        "26480",
        "26490",
        "26500",
        "26510",
        "26520",
        "26530",
        "26540",
        "26550",
        "26560",
        "26570",
        "26580",
        "26590",
        "26600",
        "29420",
        "29490",
        "35200",
        "35210",
        "35220",
        "35230",
        "35240",
        "35400",
        "35410",
        "35420",
        "35430",
        "35440",
        "35450",
        "35460",
        "35470",
        "35480",
        "35490",
        "35500",
        "35510",
        "35520",
        "35530",
        "38470",
        "38500",
        "40430",
        "40480",
        "40520",
        "40530",
        "40540",
        "44200",
        "44400",
        "44410",
        "44420",
        "45200",
        "45400",
        "47200",
        "47400",
        "47410",
        "48200",
        "48400",
        "48410",
        "48420",
        "48430",
        "48440",
        "48450",
        "48460",
        "49430",
        "49440",
        "49470",
        "49490",
        "53410",
        "54010",
        "54200",
        "54210",
        "54400",
        "54410",
        "54420",
        "54430",
        "54450",
        "54460",
        "54470",
        "54480",
        "54490",
        "54500",
        "54510",
        "54520",
        "54530",
        "54540",
        "54560",
        "54570",
        "54580",
        "54590",
        "54600",
        "54610",
        "54620",
        "54630",
        "54640",
        "54650"
    ],
    "5": [
        "20200",
        "20210",
        "20220",
        "20230",
        "20400",
        "20410",
        "20420",
        "20430",
        "20440",
        "20450",
        "20460",
        "20470",
        "20480",
        "20490",
        "20500",
        "20510",
        "20520",
        "20530",
        "20540",
        "20550",
        "20560",
        "20570",
        "25200",
        "25210",
        "25400",
        "25410",
        "25420",
        "25430",
        "25440",
        "25450",
        "25460",
        "25470",
        "25480",
        "25490",
        "25500",
        "25510",
        "25520",
        "25530",
        "25540",
        "25550",
        "25560",
        "25570",
        "26450",
        "26520",
        "26590",
        "30490",
        "31560",
        "31570",
        "31590",
        "34200",
        "34400",
        "38450",
        "38470",
        "38570",
        "38580",
        "40010",
        "40200",
        "40210",
        "40220",
        "40400",
        "40410",
        "40420",
        "40430",
        "40440",
        "40450",
        "40460",
        "40470",
        "40480",
        "40490",
        "40500",
        "40510",
        "40520",
        "40530",
        "40540",
        "40550",
        "41400",
        "48440"
    ],
    "6": [
        "25460",
        "25570",
        "28200",
        "28210",
        "28400",
        "28410",
        "28420",
        "28430",
        "28440",
        "28450",
        "28460",
        "28470",
        "28480",
        "28490",
        "28500",
        "28510",
        "28520",
        "28530",
        "28540",
        "28550",
        "28560",
        "28570",
        "28580",
        "30400",
        "30410",
        "30420",
        "30430",
        "30440",
        "30450",
        "30460",
        "30470",
        "30480",
        "30490",
        "30500",
        "30510",
        "30520",
        "30530",
        "30540",
        "30550",
        "33440",
        "34200",
        "34210",
        "34400",
        "34410",
        "34420",
        "39400",
        "39410",
        "39420",
        "40550",
        "41200",
        "41400",
        "45400",
        "46400",
        "46430",
        "46440",
        "46520",
        "46540",
        "46550",
        "51400",
        "51420",
        "51470",
        "51490",
        "52200",
        "52210",
        "52400",
        "52410",
        "52420",
        "52430",
        "52440",
        "52450",
        "52460",
        "52470",
        "52480",
        "52490",
        "52500",
        "52510",
        "52520",
        "52530",
        "52540",
        "52550",
        "52560",
        "52570",
        "52580",
        "52590",
        "52600"
    ],
    "7": [
        "33400",
        "33410",
        "33510",
        "51200",
        "51210",
        "51220",
        "51230",
        "51400",
        "51410",
        "51420",
        "51430",
        "51440",
        "51450",
        "51460",
        "51470",
        "51480",
        "51490",
        "51500",
        "51510",
        "51520",
        "51530",
        "51540",
        "51550",
        "51560",
        "51570",
        "52400",
        "56200",
        "56400",
        "56410",
        "56420",
        "56430",
        "56440",
        "56450",
        "56460",
        "56470",
        "56480",
        "56490",
        "56500",
        "56510"
    ],
    "8": [
        "20400",
        "21470",
        "24200",
        "24210",
        "24400",
        "24410",
        "24420",
        "24430",
        "24440",
        "24450",
        "24460",
        "24470",
        "24480",
        "24490",
        "24500",
        "24510",
        "24520",
        "24530",
        "24540",
        "24550",
        "24560",
        "24570",
        "24580",
        "26430",
        "26440",
        "29420",
        "29480",
        "31420",
        "32410",
        "32460",
        "32520",
        "32600",
        "32610",
        "37200",
        "37210",
        "37220",
        "37400",
        "37410",
        "37420",
        "37430",
        "37440",
        "37450",
        "37460",
        "37470",
        "37480",
        "37490",
        "37500",
        "37510",
        "37520",
        "37530",
        "37540",
        "37550",
        "37560",
        "37570",
        "37580",
        "37590",
        "37600",
        "37610",
        "38200",
        "38210",
        "38220",
        "38400",
        "38410",
        "38420",
        "38430",
        "38440",
        "38460",
        "38470",
        "38480",
        "38490",
        "38500",
        "38510",
        "38520",
        "38530",
        "38540",
        "38550",
        "38560",
        "38580",
        "42420",
        "42490",
        "42500",
        "43200",
        "43400",
        "43410",
        "43420",
        "43430",
        "43440",
        "43450",
        "43460",
        "43470",
        "43480",
        "43490",
        "43500",
        "43510",
        "43520",
        "43530",
        "43540",
        "43550",
        "43560",
        "43570",
        "43580",
        "43590",
        "43600",
        "43610",
        "43620",
        "43630",
        "43640",
        "43650",
        "43660",
        "43670",
        "55200",
        "55400",
        "55410"
    ]
};

export const lvmForestry_Regions: { [lvmForestry: string]: string[] } = {
    "1": ["21000", "24000", "26000", "29000", "38000", "49000", "53000", "54000"],
    "2": ["27000", "28000", "33000", "46000", "5000", "51000", "52000", "56000"],
    "3": ["2000", "20000", "22000", "31000", "32000", "36000", "37000", "38000", "42000", "43000"],
    "4": [
        "1000",
        "23000",
        "26000",
        "29000",
        "35000",
        "38000",
        "40000",
        "44000",
        "45000",
        "47000",
        "48000",
        "49000",
        "53000",
        "54000"
    ],
    "5": ["20000", "25000", "26000", "30000", "31000", "34000", "38000", "40000", "41000", "48000"],
    "6": [
        "1000",
        "25000",
        "28000",
        "3000",
        "30000",
        "33000",
        "34000",
        "39000",
        "4000",
        "40000",
        "41000",
        "45000",
        "46000",
        "51000",
        "52000"
    ],
    "7": ["33000", "51000", "52000", "56000", "7000"],
    "8": [
        "20000",
        "21000",
        "24000",
        "26000",
        "29000",
        "31000",
        "32000",
        "37000",
        "38000",
        "42000",
        "43000",
        "55000",
        "6000"
    ]
};
